import(/* webpackMode: "eager", webpackExports: ["ProductEvents"] */ "/codebuild/output/src2670008425/src/apps/nextjs-bigcommerce/components/analytics/product/product-events.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RenderBuilderSection"] */ "/codebuild/output/src2670008425/src/apps/nextjs-bigcommerce/components/builder/builder-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductOptionsProvider"] */ "/codebuild/output/src2670008425/src/apps/nextjs-bigcommerce/components/providers/product-options-provider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2670008425/src/packages/shared-react-components/src/builder/components/rte.css");
